<template>
  <div>
    <CommonHeader :page="'Tableau de board'" class="pb-6 pb-8" />
    <!--Charts-->
    <div class="container-fluid mt--7 pb-1" v-if="stats">
      <div class="row" v-if="!isSupervisor">
        <div class="col-md-6 col-xl-3">
          <div class="card bg-c-blue order-card">
            <div class="card-block">
              <h6 class="m-b-20">Articles déposés</h6>
              <h2 class="text-right">
                <!-- <i class="ti-shopping-cart f-left"></i> -->
                <ThemifyIcon class="f-left" icon="shopping-cart" />
                <span style="font-size: 20px">{{ stats.deposed.nbr }}</span>
              </h2>
              <p class="m-b-0">
                Ce mois
                <span class="f-right">{{ stats.deposed.price }} DT</span>
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-xl-3">
          <div class="card bg-c-green order-card">
            <div class="card-block">
              <h6 class="m-b-20">Articles vendus</h6>
              <h2 class="text-right">
                <ThemifyIcon class="f-left" icon="tag" />
                <span style="font-size: 20px">{{ stats.soldProducts }}</span>
              </h2>
              <p class="m-b-0">Ce mois</p>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-xl-3">
          <div class="card bg-c-yellow order-card">
            <div class="card-block">
              <h6 class="m-b-20">Transactions</h6>
              <h2 class="text-right">
                <ThemifyIcon class="f-left" icon="reload" />
                <span style="font-size: 20px">{{ stats.revenue }}</span>
              </h2>
              <p class="m-b-0">Ce mois</p>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-xl-3">
          <div class="card bg-c-pink order-card">
            <div class="card-block">
              <h6 class="m-b-20">Commission totale</h6>
              <h2 class="text-right">
                <!-- <i class="ti-wallet f-left"></i> -->
                <ThemifyIcon class="f-left" icon="wallet" />
                <span style="font-size: 20px">{{ stats.benefit }} DT</span>
              </h2>
              <p class="m-b-0">Ce mois</p>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-xl-3">
          <div class="card bg-c-darkbleu order-card">
            <div class="card-block">
              <h6 class="m-b-20">Recette du jour</h6>
              <h2 class="text-right">
                <!-- <i class="ti-wallet f-left"></i> -->
                <ThemifyIcon class="f-left" icon="wallet" />
                <span style="font-size: 20px">{{ recetteValue }} DT</span>
              </h2>
              <p class="m-b-0">Aujourd'hui</p>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-xl-3">
          <div class="card bg-c-darkPink order-card">
            <div class="card-block">
              <h6 class="m-b-20">Commissions du jour</h6>
              <h2 class="text-right">
                <!-- <i class="ti-wallet f-left"></i> -->
                <ThemifyIcon class="f-left" icon="wallet" />
                <span style="font-size: 20px">{{ revenueValue }} DT</span>
              </h2>
              <p class="m-b-0">Aujourd'hui</p>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-xl-3">
          <div class="card bg-c-darkbleu2 order-card">
            <div class="card-block">
              <h6 class="m-b-20">Recettes journalières moyenne</h6>
              <h2 class="text-right">
                <!-- <i class="ti-wallet f-left"></i> -->
                <ThemifyIcon class="f-left" icon="wallet" />
                <span style="font-size: 20px"
                  >{{ recetteMoyenneValue }} DT</span
                >
              </h2>
              <p class="m-b-0">Jusqu'à aujourd'hui</p>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-xl-3">
          <div class="card bg-c-darkPink2 order-card">
            <div class="card-block">
              <h6 class="m-b-20">Commission journalière moyenne</h6>
              <h2 class="text-right">
                <!-- <i class="ti-wallet f-left"></i> -->
                <ThemifyIcon class="f-left" icon="wallet" />
                <span style="font-size: 20px"
                  >{{ revenueMoyenneValue }} DT</span
                >
              </h2>
              <p class="m-b-0">Jusqu'à aujourd'hui</p>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-xl-4">
          <div class="card bg-c-blue order-card">
            <div class="card-block">
              <h6 class="m-b-20">Paiements du jour</h6>
              <h2 class="text-right">
                <!-- <i class="ti-wallet f-left"></i> -->
                <ThemifyIcon class="f-left" icon="wallet" />
                <span style="font-size: 20px">{{ paidToday }} DT</span>
              </h2>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-xl-4">
          <div class="card bg-c-green order-card">
            <div class="card-block">
              <h6 class="m-b-20">Paiements à venir</h6>
              <h2 class="text-right">
                <!-- <i class="ti-wallet f-left"></i> -->
                <ThemifyIcon class="f-left" icon="wallet" />
                <span style="font-size: 20px">{{ toPay }} DT</span>
              </h2>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-xl-4">
          <div class="card bg-c-green order-card">
            <div class="card-block">
              <h6 class="m-b-20">Nombre article retour</h6>
              <h2 class="text-right">
                <!-- <i class="ti-wallet f-left"></i> -->
                <ThemifyIcon class="f-left" icon="wallet" />
                <span style="font-size: 20px">{{ smsNbr }} articles</span>
              </h2>
            </div>
          </div>
        </div>
      </div>
      <div class="row" v-if="isSupervisor">
        <div class="col-md-6 col-xl-3">
          <div class="card bg-c-darkbleu order-card">
            <div class="card-block">
              <h6 class="m-b-20">Recette du jour</h6>
              <h2 class="text-right">
                <!-- <i class="ti-wallet f-left"></i> -->
                <ThemifyIcon class="f-left" icon="wallet" />
                <span style="font-size: 20px">{{ recetteValue }} DT</span>
              </h2>
              <p class="m-b-0">Aujourd'hui</p>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-xl-3">
          <div class="card bg-c-blue order-card">
            <div class="card-block">
              <h6 class="m-b-20">Paiements du jour</h6>
              <h2 class="text-right">
                <!-- <i class="ti-wallet f-left"></i> -->
                <ThemifyIcon class="f-left" icon="wallet" />
                <span style="font-size: 20px">{{ paidToday }} DT</span>
              </h2>
              <p class="m-b-0">&nbsp;</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row" style="margin-bottom: 25px" v-if="!isSupervisor">
      <b-col class="col-2 offset-3">
        <b-form-input
          :type="'date'"
          :placeholder="'De'"
          v-model="from"
        ></b-form-input>
      </b-col>
      <b-col
        class="col-2"
        style="display: flex; justify-content: center; align-items: center"
        >Jusqu'à</b-col
      >
      <b-col class="col-2">
        <b-form-input
          :type="'date'"
          :placeholder="'à'"
          v-model="to"
        ></b-form-input>
      </b-col>
    </div>
    <div class="md-layout" v-if="!isSupervisor">
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-33"
      >
        <chart-card
          :chart-data="ventesCharts.data"
          :chart-options="ventesCharts.options"
          :chart-responsive-options="ventesCharts.responsiveOptions"
          :chart-type="'Bar'"
          data-background-color="red"
          ref="ventesRef"
        >
          <template slot="content">
            <h4 class="title">Ventes</h4>
          </template>
        </chart-card>
      </div>
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-33"
      >
        <chart-card
          :chart-data="revenueChart.data"
          :chart-options="revenueChart.options"
          :chart-type="'Line'"
          data-background-color="green"
          ref="revenueChartRef"
        >
          <template slot="content">
            <h4 class="title">Bénéfice</h4>
          </template>
        </chart-card>
      </div>
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-33"
      >
        <chart-card
          :chart-data="clientsChart.data"
          :chart-options="clientsChart.options"
          :chart-type="'Line'"
          data-background-color="blue"
          ref="clientsChartRef"
        >
          <template slot="content">
            <h4 class="title">Nouveaux Clients</h4>
          </template>
        </chart-card>
      </div>
    </div>
    <div class="md-layout justify-content-center" v-if="!isSupervisor">
      <div class="col-xl-5 col-md-12 col-sm-12" style="background-color: #fff">
        <p><span style="font-weight: bold; font-size: 20px">Ventes</span></p>
        <b-table :items="items" :fields="fields" striped responsive="sm md">
        </b-table>
      </div>
      <div class="clear col-xl-1" style="height: 25px"></div>
      <div class="col-xl-5 col-md-12 col-sm-12" style="background-color: #fff">
        <p><span style="font-weight: bold; font-size: 20px">Bénéfice</span></p>
        <b-table
          :items="itemsRecette"
          :fields="fields"
          striped
          responsive="sm md"
        >
        </b-table>
      </div>
    </div>
  </div>
</template>
<script>
// Charts
import * as chartConfigs from "@/components/Charts/config";
import LineChart from "@/components/Charts/LineChart";
import BarChart from "@/components/Charts/BarChart";
import CommonHeader from "@/components/CommonHeader";
import { get, post } from "@/mixins/api";
import ThemifyIcon from "vue-themify-icons";
import ChartCard from "./ChartCard";
// Tables

export default {
  components: {
    LineChart,
    BarChart,
    CommonHeader,
    ThemifyIcon,
    ChartCard,
  },
  data() {
    return {
      paidToday: 0,
      toPay: 0,
      smsNbr: 0,
      fields: [
        { key: "Date", sortable: false },
        { key: "Montant", sortable: false },
      ],
      redBarChart: {
        chartData: {
          labels: [],
          datasets: [
            {
              label: "Ventes",
              data: [25, 20, 30, 22, 17, 29],
            },
          ],
        },
      },
      redBarChartRevenue: {
        chartData: {
          labels: [],
          datasets: [
            {
              label: "Ventes",
              data: [25, 20, 30, 22, 17, 29],
            },
          ],
        },
      },
      stats: undefined,
      from: "",
      to: "",
      fromRevenue: "",
      toRevenue: "",
      filter: {
        from: "",
        to: "",
      },
      toggleChart: false,
      recette: 0,
      recetteMoyenne: 0,
      revenue: 0,
      revenueMoyenne: 0,
      dataSales: {},
      dataRevenues: {},
      clientsChart: {
        data: {
          labels: ["M", "T", "W", "T", "F", "S", "S"],
          series: [[12, 17, 7, 17, 23, 18, 38]],
        },
        options: {
          lineSmooth: this.$Chartist.Interpolation.cardinal({
            tension: 0,
          }),
          low: 0,
          high: 50, // creative tim: we recommend you to set the high sa the biggest value + something for a better look
          chartPadding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 30,
          },
        },
      },
      revenueChart: {
        data: {
          labels: ["12am", "3pm", "6pm", "9pm", "12pm", "3am", "6am", "9am"],
          series: [[230, 750, 450, 300, 280, 240, 200, 190]],
        },

        options: {
          lineSmooth: this.$Chartist.Interpolation.cardinal({
            tension: 0,
          }),
          low: 0,
          high: 1000, // creative tim: we recommend you to set the high sa the biggest value + something for a better look
          chartPadding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 30,
          },
        },
      },
      ventesCharts: {
        data: {
          labels: [
            "Ja",
            "Fe",
            "Ma",
            "Ap",
            "Mai",
            "Ju",
            "Jul",
            "Au",
            "Se",
            "Oc",
            "No",
            "De",
          ],
          series: [
            [542, 443, 320, 780, 553, 453, 326, 434, 568, 610, 756, 895],
          ],
        },
        options: {
          axisX: {
            showGrid: false,
          },
          low: 0,
          high: 1000,
          chartPadding: {
            top: 0,
            right: 5,
            bottom: 0,
            left: 30,
          },
        },
        responsiveOptions: [
          [
            "screen and (max-width: 640px)",
            {
              seriesBarDistance: 5,
              axisX: {
                labelInterpolationFnc: function (value) {
                  return value[0];
                },
              },
            },
          ],
        ],
      },
    };
  },
  watch: {
    from: {
      handler: function (newVal) {
        if (this.from != "" && this.to != "") {
          this.initChart({ from: this.from, to: this.to });
          this.initChartRevenue({ from: this.from, to: this.to });
          this.initChartClient({ from: this.from, to: this.to });
        }
      },
    },
    to: {
      handler: function (newVal) {
        if (this.from != "" && this.to != "") {
          this.initChart({ from: this.from, to: this.to });
          this.initChartRevenue({ from: this.from, to: this.to });
          this.initChartClient({ from: this.from, to: this.to });
        }
      },
    },
    fromRevenue: {
      handler: function (newVal) {
        if (this.fromRevenue != "" && this.toRevenue != "") {
          this.initChartRevenue({ from: this.fromRevenue, to: this.toRevenue });
        }
      },
    },
    toRevenue: {
      handler: function (newVal) {
        if (this.fromRevenue != "" && this.toRevenue != "") {
          this.initChartRevenue({ from: this.fromRevenue, to: this.toRevenue });
        }
      },
    },
  },
  computed: {
    isSupervisor() {
      return false;
    },
    recetteValue() {
      return (this.recette || 0).toFixed(2);
    },
    recetteMoyenneValue() {
      return (this.recetteMoyenne || 0).toFixed(2);
    },
    revenueValue() {
      return (this.revenue || 0).toFixed(2);
    },
    revenueMoyenneValue() {
      return (this.revenueMoyenne || 0).toFixed(2);
    },
    items() {
      return Object.keys(this.dataSales).reduce((acc, item) => {
        acc.push({
          Date: item,
          Montant: this.dataSales[item].prices.toFixed(2) + " DT",
        });
        return acc;
      }, []);
    },
    itemsRecette() {
      return Object.keys(this.dataRevenues).reduce((acc, item) => {
        acc.push({
          Date: item,
          Montant: this.dataRevenues[item].prices.toFixed(2) + " DT",
        });
        return acc;
      }, []);
    },
  },
  methods: {
    initChartRevenue(filter) {
      post("getStatsRecette", filter).then((res) => {
        this.dataRevenues = res.data;
        this.revenueChart.data.labels = Object.keys(res.data);
        this.revenueChart.data.series[0] = Object.keys(res.data).reduce(
          (acc, key) => [...acc, res.data[key].prices],
          []
        );
        this.revenueChart.options.high = Object.keys(res.data).reduce(
          (acc, key) =>
            acc > res.data[key].prices ? acc : res.data[key].prices,
          0
        );
        this.revenueChart.options.low = Object.keys(res.data).reduce(
          (acc, key) =>
            acc < res.data[key].prices ? acc : res.data[key].prices,
          0
        );
        this.$refs.revenueChartRef.refresh();
      });
    },
    initChart(filter) {
      post("getStats", filter).then((res) => {
        this.dataSales = res.data;
        this.ventesCharts.data.labels = Object.keys(res.data);
        this.ventesCharts.data.series[0] = Object.keys(res.data).reduce(
          (acc, key) => [...acc, res.data[key].prices],
          []
        );
        this.ventesCharts.options.high = Object.keys(res.data).reduce(
          (acc, key) =>
            acc > res.data[key].prices ? acc : res.data[key].prices,
          0
        );
        this.ventesCharts.options.low = Object.keys(res.data).reduce(
          (acc, key) =>
            acc < res.data[key].prices ? acc : res.data[key].prices,
          0
        );
        this.$refs.ventesRef.refresh();
      });
    },
    initChartClient(filter) {
      post("getStatsClient", filter).then((res) => {
        this.clientsChart.data.labels = Object.keys(res.data);
        this.clientsChart.data.series[0] = Object.keys(res.data).reduce(
          (acc, key) => [...acc, res.data[key].clients],
          []
        );
        this.clientsChart.options.high = Object.keys(res.data).reduce(
          (acc, key) =>
            acc > res.data[key].clients ? acc : res.data[key].clients,
          0
        );
        this.clientsChart.options.low = Object.keys(res.data).reduce(
          (acc, key) =>
            acc < res.data[key].clients ? acc : res.data[key].clients,
          0
        );
        this.$refs.clientsChartRef.refresh();
      });
    },
  },
  mounted() {
    get("getBadges").then((res) => {
      this.stats = res.data;
    });
    get("paidToday").then((res) => {
      this.paidToday = res.data.data;
    });
    get("toPay").then((res) => {
      this.toPay = res.data.data;
    });
    get("getRecette").then((res) => {
      this.recette = res.data[0].total;
    });
    get("getRecetteMoyenne").then((res) => {
      this.recetteMoyenne = res.data.total;
    });
    get("getRevenue").then((res) => {
      this.revenue = res.data[0].total;
    });
    get("getRevenueMoyenne").then((res) => {
      this.revenueMoyenne = res.data.total;
    });
    get("outdatedproducts").then((res) => {
      this.smsNbr = res.data.count;
    });
    let date = new Date();
    const pastDate = date.getDate() - 7;
    date.setDate(pastDate);
    this.initChart({
      from: date,
      to: new Date(),
    });
    this.initChartRevenue({
      from: date,
      to: new Date(),
    });
    this.initChartClient({
      from: date,
      to: new Date(),
    });
  },
};
</script>
<style>
.card .card-block {
  padding: 10px;
}

.order-card {
  color: #fff;
}

.bg-c-blue {
  background: linear-gradient(45deg, #4099ff, #73b4ff);
}
.m-b-20 {
  margin-bottom: 20px;
}
.card {
  border-radius: 5px;
  box-shadow: 0 1px 2.94px 0.06px rgba(4, 26, 55, 0.16);
  border: none;
  margin-bottom: 30px;
  transition: all 0.3s ease-in-out;
}
.card .card-block p {
  line-height: 1.4;
}
.m-b-0 {
  margin-bottom: 0;
}
p {
  font-size: 14px;
}
.order-card i {
  font-size: 26px;
}
.f-left {
  float: left;
}
[class^="ti-"],
[class*=" ti-"] {
  font-family: themify;
  speak: none;
  font-style: normal;
  font-weight: 400;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.ti-wallet:before {
  content: "\e6cd";
}
.ti-wallet:before {
  content: "\e6cd";
}
.ti-shopping-cart:before {
  content: "\e60d";
}
.ti-reload:before {
  content: "\e619";
}
.ti-tag:before {
  content: "\e608";
}
.bg-c-green {
  background: linear-gradient(45deg, #2ed8b6, #59e0c5);
}
.bg-c-yellow {
  background: linear-gradient(45deg, #ffb64d, #ffcb80);
}
.bg-c-pink {
  background: linear-gradient(45deg, #ff5370, #ff869a);
}
.bg-c-darkbleu {
  background: linear-gradient(45deg, #00008b, #b0c4de);
}
.bg-c-darkbleu2 {
  background: linear-gradient(45deg, #6495ed, #b0c4de);
}
.bg-c-darkPink {
  background: linear-gradient(45deg, #ff69b4, #ffb6c1);
}
.bg-c-darkPink2 {
  background: linear-gradient(45deg, #ff1493, #ffb6c1);
}
h6 {
  font-weight: 600;
}
h6 {
  font-size: 12px;
}
.m-b-0 {
  margin-bottom: 0;
}
p {
  font-size: 14px;
}
.f-right,
.f-left,
.text-right,
.m-b-20 {
  color: white;
}
.f-right {
  float: right;
}
</style>
